import { render, staticRenderFns } from "./ListMetalWithdraw.vue?vue&type=template&id=46bb20d4&scoped=true&"
import script from "./ListMetalWithdraw.vue?vue&type=script&lang=js&"
export * from "./ListMetalWithdraw.vue?vue&type=script&lang=js&"
import style0 from "./ListMetalWithdraw.vue?vue&type=style&index=0&id=46bb20d4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46bb20d4",
  null
  
)

export default component.exports